import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateUser } from 'api/users/use-create-user';
import { withRoleGuard } from 'shared/hocs/with-role-guard';
import { UserRole } from 'shared/hooks/use-role-guard';
import { FormDrawerWithButton } from 'components/common/form-drawer-with-button';
import { UserForm } from 'components/users/user-form';
import type { IUserFormFields } from 'components/users/user-form';

const UserCreateComponent: React.FC = () => {
  const { t } = useTranslation();
  const { mutateAsync: createUser, isLoading } = useCreateUser();

  const handleFinish = async (values: IUserFormFields) => {
    const apiVariables = {
      name: values.name,
      email: values.email,
      role: values.role,
      phone: values.phone,
      phoneDescription: values.phoneDescription,
      bonusLimit: values.bonusLimit ?? 0,
      bonusPercent: values.bonusPercent ?? 0,
    };

    await createUser(apiVariables);
  };

  return (
    <FormDrawerWithButton
      formComponent={UserForm}
      title={t('user:add_user')}
      buttonLabel={t('user:add_user')}
      isLoading={isLoading}
      onFinish={handleFinish}
    />
  );
};

export const UserCreate = withRoleGuard(UserCreateComponent, [UserRole.admin]);
